export default __webpack_public_path__ + "static/media/9.49b06c3e.jpg";